/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class AppointmentResourceAPI extends ApiClient {
  constructor(resource) {
    super(`wasapi/${resource}`, { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }
}

export const practitionersAPI = new AppointmentResourceAPI(
  'appointment_practitioners'
);
export const servicesAPI = new AppointmentResourceAPI('appointment_services');
export const partnerTypesAPI = new AppointmentResourceAPI(
  'appointment_partner_types'
);
export const partnersAPI = new AppointmentResourceAPI('appointment_partners');
export const customersAPI = new AppointmentResourceAPI('appointment_customers');
export const reasonsAPI = new AppointmentResourceAPI('appointment_reasons');
export const blocksAPI = new AppointmentResourceAPI('appointment_blocks');
export const appointmentsAPI = new AppointmentResourceAPI('appointments');

const configUrl = () => new AppointmentResourceAPI('appointment_config').url;

export const remindersAPI = {
  list: serviceId => axios.get(`${servicesAPI.url}/${serviceId}/reminders`),
  create: (serviceId, data) =>
    axios.post(`${servicesAPI.url}/${serviceId}/reminders`, data),
  update: (serviceId, id, data) =>
    axios.patch(`${servicesAPI.url}/${serviceId}/reminders/${id}`, data),
  delete: (serviceId, id) =>
    axios.delete(`${servicesAPI.url}/${serviceId}/reminders/${id}`),
};

export const customerByPhone = phone =>
  axios.get(`${customersAPI.url}/by_phone`, { params: { phone } });
export const availability = params =>
  axios.get(`${appointmentsAPI.url}/availability`, { params });
export const cancelAppointment = (id, data) =>
  axios.patch(`${appointmentsAPI.url}/${id}/cancel`, data);
export const rescheduleAppointment = (id, data) =>
  axios.patch(`${appointmentsAPI.url}/${id}/reschedule`, data);
export const appointmentEvents = id =>
  axios.get(`${appointmentsAPI.url}/${id}/events`);
export const getConfig = () => axios.get(configUrl());
export const updateConfig = data => axios.patch(configUrl(), data);
